import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Divider } from '@mui/material';
import AddResultStory from './AddResultStory';
import ResultStoryTable from './ResultStoryTable'
import getAccess from '../../../utils/getAccess';
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const  ResultStory = () => {
    const access = getAccess();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            
            <Box sx={{ borderBottom: 1, borderColor: 'divider', }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ width: '100%', }}>
                    <Tab label="Result Story" sx={{ width: '100%' }} {...a11yProps(0)} />
                    {(access?.access?.includes('9111') || access?.access.includes('all')) && (<Tab label="Add Result Story" sx={{ width: '100%' }} {...a11yProps(1)} />)}
                </Tabs>
    
            </Box>
            <TabPanel value={value} index={0}>
                <ResultStoryTable />
            </TabPanel>
            {(access?.access?.includes('9111') || access?.access.includes('all')) && (<TabPanel value={value} index={1}>
                <AddResultStory />
            </TabPanel>)}

        </Box >
    );
}

export default ResultStory